import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BadBuyerGroupsDialogComponent } from '../bad-buyer-groups-dialog/bad-buyer-groups-dialog.component';
import { MatHeaderCell, MatCell, MatHeaderRow, MatRow, MatTable, MatTableModule } from "@angular/material/table";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from '@angular/material/button';


export interface BadBuyer {
  account: string;
  name: string;
  messages: string[];
}

@Component({
  selector: 'tc-bad-buyers',
  templateUrl: './bad-buyers.component.html',
  styleUrls: ['./bad-buyer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatHeaderCell, MatCell, MatIcon, MatMenu, MatHeaderRow, MatRow, MatTable, MatButtonModule, MatMenuModule, MatTableModule],
})
export class BadBuyersComponent {
  private dialog = inject(MatDialog)

  displayedColumns = ['name', 'account', 'reasons', 'actions'];
  expandedBuyer: string | null = null;

  @Input() badBuyers: BadBuyer[] = [];
  @Input() loading = false;
  @Input() error = false;
  @Output() reload = new EventEmitter<void>();

  openGroupsDialog(buyer: BadBuyer): void {
    this.dialog.open(BadBuyerGroupsDialogComponent, {
      width: '570px',
      data: { buyer },
    });
  }
}
